var $2fa80cee796b989c$exports = {};
$2fa80cee796b989c$exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B} \u{442}\u{440}\u{438}\u{432}\u{43E}\u{433}\u{438}`,
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};


export {$2fa80cee796b989c$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
